import { render, staticRenderFns } from "./ItemListMyTempSaveLayout.vue?vue&type=template&id=6065af3e&scoped=true&"
import script from "./ItemListMyTempSaveLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListMyTempSaveLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065af3e",
  null
  
)

export default component.exports